// Shared table styles used by OutletSellTable and ProductDataTable
// Place this file at:  src/.../ProductLevelChallanData/styles/tableStyles.js

import { blackishGrayColor, lightBrownColor, lightWhiteRedShadeColor, strongBlue, white, whiteBlueShade } from "../../../config/ColorObj";


export const tableStyles = {
    table: {
        width: "100%",
        borderCollapse: "collapse",
        fontSize: 13,
        backgroundColor: white,
        borderRadius: 8,
        overflow: "hidden",
        border: "0.5px solid #e8e8e8",
    },
    th: {
        textAlign: "left",
        padding: "9px 12px",
        color: "#7f7e7e",
        fontWeight: 600,
        fontSize: 12,
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        backgroundColor: lightWhiteRedShadeColor,
        borderBottom: "0.5px solid #e8e8e8",
    },
    td: {
        padding: "10px 12px",
        color: blackishGrayColor,
        fontSize: 13,
    },
    // Apply to every row except the last to avoid double-border at table bottom
    row: {
        borderBottom: "0.5px solid #f0f0f0",
    },
    badge: {
        display: "inline-block",
        padding: "3px 11px",
        borderRadius: 20,
        background: whiteBlueShade,
        color: strongBlue,
        fontWeight: 600,
        fontSize: 12,
    },
    emptyText: {
        fontSize: 13,
        color: lightBrownColor,
        textAlign: "center",
        padding: "24px 0",
        margin: 0,
    },
};